import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { GlobalService } from '../../shared/services/global/global.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ENTITY_NAMES, TABLE_OPTION_VALUES } from '../../shared/constants/api-constants';
import { PopoverController } from '@ionic/angular';
import { ColumnManageComponent } from '../../shared/popover/column-manage/column-manage.component';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';

@Component({
  selector: 'app-visa-passenger-grid',
  templateUrl: './visa-passenger-grid.component.html',
  styleUrls: ['./visa-passenger-grid.component.scss']
})
export class VisaPassengerGridComponent implements OnInit {

  @Input() allData: any;
  @Input() data: any;
  @Input() hidePaginations: any = false;
  paginationSettings: any;
  visiblePages: number[] = [];
  noOfRows: any = 0;

  @Input() columns: any = [];
  @Input() showColumnSelector: boolean = true;
  initialColumns: any = [];

  @Input() hideExtraColumns: boolean = false;

  @Output() paginationsUpdated = new EventEmitter<void>();
  @Output() manageColumnsChange = new EventEmitter<any>();

  // Multi select related variables
  selectedRowIds: any[] = [];
  @Input() multiSelectProperty: string | null = null;

  // Keep track of the current sort order for each column
  sortOrder: { [key: string]: 'asc' | 'desc' } = {};

  constructor(
    public _globalService: GlobalService,
    private _modalService: ModalsService,
    private _visaService: VisaService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _popoverController: PopoverController,
    private _lovDataService: LovDataService
  ) { }

  ngOnInit() {
    this.initialColumns = this.getVisibleColumns(this.columns);
  }

  ngOnChanges() {
    this.paginationSettings = this.allData;
    this.data = this.allData.data;
    this.noOfRows = this.data?.length;
    this.updateVisiblePages();
  }

  toggleRowVisibility(index: number) {
    this.data[index].isExpanded = !this.data[index].isExpanded;
  }

  calculateAge(dateOfBirth: any) {
    return this._globalService.calculateAge(dateOfBirth);
  }

  openVisaReviewScreen(visaId: any) {
    this._modalService.openVisaReviewScreen(visaId);
  }

  openVisaModalForm(leadId: any, visaId: any) {
    this._modalService.openVisaCreationModal(leadId, visaId);
  }

  showAuditHistory(id: any) {
    this._lovDataService.getAuditData(id, "Visa").subscribe((data) => {
      this._modalService.openAuditHistoryView(ENTITY_NAMES.VISA, id, data, "Visa");
    });
  }

  async deleteLeadRow(visaId: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${visaId}`, "Confirm Delete", "Yes")) {
      this._visaService.deleteVisa(visaId).subscribe(data => {
        if (data) {
          this._responseNotificationService.showMessage("Visa Deleted Successfully.")
        }
      })
    }
  }

  convertToDate(value: any): any {
    if (value) {
      return new Date(value);
    } else {
      return null;
    }
  }

  async showVisaGridOptions(ev: any, row: any) {
    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: {
          options: [
            {
              value: "View",
              path: TABLE_OPTION_VALUES.VIEW
            },
            {
              value: "Edit",
              path: TABLE_OPTION_VALUES.EDIT
            },
            {
              value: "Audit History",
              path: TABLE_OPTION_VALUES.SHOW_AUDIT
            },
            {
              value: "Delete",
              path: TABLE_OPTION_VALUES.DELETE
            }
          ]
        },
        onPathSelected: (data: any) => this.onOptionSelected(data, row)
      }
    });
    return await popover.present();
  }

  onOptionSelected(data: any, row: any) {
    switch (data.path) {
      case TABLE_OPTION_VALUES.DELETE: {
        this.deleteLeadRow(row.visaId);
        break;
      }
      case TABLE_OPTION_VALUES.EDIT: {
        this.openVisaModalForm(row.leadId, row.visaId);
        break;
      }
      case TABLE_OPTION_VALUES.SHOW_AUDIT: {
        this.showAuditHistory(row.visaId);
        break;
      }
      case TABLE_OPTION_VALUES.VIEW: {
        this.openVisaReviewScreen(row.visaId);
        break;
      }
    }
  }

  getSelectedStatus(data: any[]) {
    if (data) {
      const lastCheckedItem = [...data].reverse().find(item => item.checked);
      return lastCheckedItem ? lastCheckedItem.name : null;
    } else {
      return null;
    }

  }

  // Update from grid funtions

  enableVisaEdit(passengerIndex: number) {
    this.data[passengerIndex].isEditable = true;
  }

  visaDocumentValidFromChanged(value: any, passengerIndex: number, documentIndex: number) {
    this.data[passengerIndex].documents[documentIndex].validFrom = value;
  }

  visaDocumentValidToChanged(value: any, passengerIndex: number, documentIndex: number) {
    this.data[passengerIndex].documents[documentIndex].validTo = value;
  }

  openAttachment(file: any) {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      this._modalService.openImageModal(fileURL)
    } else {
      this._modalService.openImageModal(file)
    }
  }

  onDocumentSelected(event: any, passengerIndex: number, docIndex: number) {
    const file = event.target.files[0];
    // Checking if image is more than 10MB
    if (file.size > 10 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 10MB", "Invalid File Size");
      return;
    }
    if (file) {
      let data = new FormData();
      data.append('image', file);
      try {
        this._visaService.uploadDocumentForVisaPassenger(data).subscribe((res) => {
          this.data[passengerIndex].documents[docIndex].document = file;
          this.data[passengerIndex].documents[docIndex].imagePath = res;
        })
      } catch (error) {
        console.error("Error while uploading doc", error);
        this._responseNotificationService.showMessage("Failed to upload document, please try again.", true);
      }
    }
  }

  saveVisaRecord(passengerIndex: number) {
    const visaPassenger = this.data[passengerIndex];
    this._visaService.getVisa(visaPassenger.visaId).subscribe({
      next: (data: any) => {
        this.updateVisaDocumentCollection(data.visaDocuments, visaPassenger, passengerIndex);
      },
      error: (err: any) => {
        this._responseNotificationService.showMessage("Failed to save visa record, please try again.", true);
      }
    });
  }

  updateVisaDocumentCollection(visaDocuments: any, updatedRecord: any, passengerIndex: number) {
    const targetPassengerIndex = visaDocuments.data.findIndex((doc: any) => doc.contactId === updatedRecord.contactId);
    visaDocuments.data[targetPassengerIndex] = updatedRecord;
    this._visaService.addVisaDocumentCollection(visaDocuments).subscribe({
      next: (res: any) => {
        // this._reloadService.triggerVisaLeadReload();
        this._responseNotificationService.showMessage("Visa record saved successfully.");
        this.data[passengerIndex].isEditable = false;
      },
      error: (err: any) => {
        this._responseNotificationService.showMessage("Failed to save visa record, please try again.", true);
      }
    })
  }

  // Manage columns

  async openColumnOptions(ev: any) {
    const columnPopOver = await this._popoverController.create({
      component: ColumnManageComponent,
      event: ev,
      componentProps: { columns: this.cloneVariable(this.columns) },
      cssClass: "popup-component"
    })
    await columnPopOver.present();
    const { data } = await columnPopOver.onDidDismiss();
    if (data) {
      this.columns = data;
      this.initialColumns = data.filter((column: { showColumn: any; }) => column.showColumn);
      this.manageColumnsChange.emit(data);
    } else {
      this.resetColumn();
      this.ngOnInit();
    }
  }

  resetColumn() {
    this.initialColumns = this.columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  getVisibleColumns(columns: any) {
    return columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  shouldShowColumn(colKey: any): boolean {
    return this.initialColumns.some((column: any) => column.key === colKey && column.showColumn);
  }

  getfullColSpan() {
    let colspan = this.initialColumns.length
    if (this.showColumnSelector) {
      colspan = colspan + 1;
    }
    colspan = colspan + 1;
    return colspan;
  }

  cloneVariable(variable: any) {
    return JSON.parse(JSON.stringify(variable));
  }

  // Multi select variables

  // Check if all rows are selected
  isAllSelected(): boolean {
    if (!this.data || !this.multiSelectProperty) return false;
    return this.data.length > 0 && this.selectedRowIds.length === this.data.length;
  }

  // Toggle all rows
  toggleSelectAllRows(event: any) {
    if (event.target.checked) {
      this.selectedRowIds = this.data.map((row: any) => row[this.multiSelectProperty as string]);
    } else {
      this.selectedRowIds = [];
    }
  }

  // Toggle single row
  toggleSelectRow(event: any, row: any) {
    const id = row[this.multiSelectProperty as string];
    if (event.target.checked) {
      if (!this.selectedRowIds.includes(id)) {
        this.selectedRowIds.push(id);
      }
    } else {
      this.selectedRowIds = this.selectedRowIds.filter(selectedId => selectedId !== id);
    }
  }

  // Utility to check if a row is selected
  isRowSelected(row: any): boolean {
    return this.selectedRowIds.includes(row[this.multiSelectProperty as string]);
  }

  getSelectedRows(): any[] {
    if (!this.data || !this.multiSelectProperty) {
      return [];
    }
    // Only return selected rows that are present in the current page's data
    const selectedRows = this.data.filter((row: any) =>
      this.selectedRowIds.includes(row[this.multiSelectProperty as string])
    );
    return selectedRows;
  }

  areRowsSelected(): boolean {
    if (this.selectedRowIds && this.selectedRowIds.length > 0) {
      return true;
    }
    return false;
  }

  sortData(column: string) {
    // Toggle sort order
    this.sortOrder[column] = this.sortOrder[column] === 'asc' ? 'desc' : 'asc';

    const order = this.sortOrder[column];

    this.data.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[column];
      const valueB = b[column];

      let comparison = 0;

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        comparison = valueA.localeCompare(valueB);
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        comparison = valueA - valueB;
      } else if (valueA instanceof Date && valueB instanceof Date) {
        comparison = valueA.getTime() - valueB.getTime();
      }

      return order === 'asc' ? comparison : -comparison;
    });
  }

  // Paginations
  updateVisiblePages() {
    const currentPage = this.paginationSettings.pageNumber;
    const totalPages = this.paginationSettings.totalPages;

    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    this.visiblePages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
  }

  onPageChange(page: number) {
    if (page !== this.paginationSettings.pageNumber) {
      this.paginationSettings.pageNumber = page;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onNext() {
    if (this.paginationSettings.pageNumber < this.paginationSettings.totalPages) {
      this.paginationSettings.pageNumber++;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPrevious() {
    if (this.paginationSettings.pageNumber > 1) {
      this.paginationSettings.pageNumber--;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPageSizeChange() {
    this.paginationSettings.pageNumber = 1;
    this.updateVisiblePages();
    this.loadPageData();
  }

  loadPageData() {
    // Implement the function to load data for the current page
    this.paginationsUpdated.emit(this.paginationSettings);
  }

}
